import L from 'leaflet'
import 'leaflet.heat'
import { createLayerComponent } from '@react-leaflet/core'

const createHeatLayer = ({ points, ...options }, ctx) => {
    const instance = L.heatLayer(points, options)

    // Patch _redraw to guard against null _map when the layer is removed
    // while an animation frame is still pending (leaflet.heat bug).
    const originalRedraw = instance._redraw
    instance._redraw = function () {
        if (!this._map) return
        originalRedraw.call(this)
    }

    // Patch the public redraw() method as well — it accesses this._map._animating
    // and is called by setLatLngs/setOptions. When the overlay is unchecked the
    // layer is removed from the map (_map → null) but the React component stays
    // mounted, so a re-render can still trigger updateHeatLayer → setLatLngs →
    // redraw() → crash.
    const originalPublicRedraw = instance.redraw
    instance.redraw = function () {
        if (!this._map) return this
        return originalPublicRedraw.call(this)
    }

    return { instance, context: { ...ctx, overlayContainer: instance } }
}

const updateHeatLayer = (instance, props, prevProps) => {
    if (props.points !== prevProps.points) {
        instance.setLatLngs(props.points)
    }

    if (
        props.radius !== prevProps.radius ||
        props.blur !== prevProps.blur ||
        props.maxZoom !== prevProps.maxZoom ||
        props.max !== prevProps.max ||
        props.minOpacity !== prevProps.minOpacity ||
        props.gradient !== prevProps.gradient
    ) {
        instance.setOptions(props)
    }
}

const HeatmapLayer = createLayerComponent(createHeatLayer, updateHeatLayer)

export { HeatmapLayer }

